// extracted by mini-css-extract-plugin
module.exports = {"root":"jobList_root__OeooR","company-info":"jobList_company-info__9Zf7W","info":"jobList_info__hDBL9"};